const firebaseConfig = {
    apiKey: 'AIzaSyCqH0mw-SBX7C80mFyqdvNMiMuJFFyk7L8',
    authDomain: 'ibnu-medical-assignment.firebaseapp.com',
    projectId: 'ibnu-medical-assignment',
    storageBucket: 'ibnu-medical-assignment.appspot.com',
    messagingSenderId: '433930748685',
    appId: '1:433930748685:web:8878cdf93664fe0e546644',
};

export default firebaseConfig;
